// extracted by css-extract-rspack-plugin
export default {"overviewTable":"_43dfa559"};